/**
 * An enumeration of the application routes.  Allows you to reference a "page" programmatically without
 * needing to worry about the route name changing.
 */
export default {

    // default route
    DEFAULT: "/",

    // the dashboard viewer
    DASHBOARD_VIEWER: "dashboards",

    // the dashboard designer library
    DASHBOARD_DESIGNER_LIBRARY: "dashboardsDesigner",

    // the dashboard designer chart configuration screen
    DASHBOARD_DESIGNER_CHART_CONFIG: "chartConfig",

    // the dashboard designer dashboard main config screen
    DASHBOARD_DESIGNER_DASHBOARD_CONFIG_MAIN: "dashboardConfigMain",

    // the dashboard designer open specific type config
    DASHBOARD_DESIGNER_DASHBOARD_CONFIG_OPEN: "dashboardsDesigner/:editType/:id/:counter",

    // the dashboard designer dashboard inputs config screen
    DASHBOARD_DESIGNER_DASHBOARD_CONFIG_INPUTS: "dashboardConfigInputs",

    // the dashboard designer dashboard drill down config screen
    DASHBOARD_DESIGNER_DASHBOARD_CONFIG_DRILL_DOWNS: "dashboardConfigDrillDowns",

    // the dashboard designer dashboard group screen
    DASHBOARD_DESIGNER_DASHBOARD_GROUPS: "dashboardGroupsAssign",

    //The admin screen - individual page.
    //It can optionally include a specific item ID and a whether it should be launching into edit mode.
    //Possible values for "mode" include: "edit".
    ADMIN: "admin(/:page)(/:id)(/:mode)",

    // the admin screen
    ADMIN_LANDING: "admin",

    // The main module landing screen
    MAIN: "main",

    // Page to display a single external(most likely attached) panel
    EXTERNAL_PANEL: "external/:panelId",

    // The external viewer route
    VIEWER: "viewer",

    // the landing and display page for an external user viewing or editing an eform
    EXTERNAL_FORMS: "forms",

    // the form or BPM designer canvas, with an optional ID of the item to view
    DESIGNER_CANVAS: "config(/:id)(/:mode)"
};
